export enum InvoiceStatus {
  Created = 'CREATED',
  /**
   * Payment sent to gateway but no response from payment system yet
   */
  Processing = 'PROCESSING',
  /**
   * Payment system approved transaction
   */
  Approved = 'APPROVED',
  /**
   * Payment system declined transaction
   */
  Rejected = 'REJECTED',
  /**
   * Invoice marked to refund, but money not returned to client yet
   */
  Refunding = 'REFUNDING',
  /**
   * Invoice refunded to client
   */
  Refunded = 'REFUNDED',
  /**
   * Invoice expired and should not be processed anymore
   */
  Cancelled = 'CANCELLED',
  /**
   * Invoice applied to subscription
   */
  Processed = 'PROCESSED',
}
